// GridComponent.js
import React, { useState, useEffect } from 'react';
import ModalPassifDescription from '../modal/ModalPassifDescription';
import { parseGroupString } from './../../utils';
import MoneyCounter from '../MoneyCounter';
import RationGrp from '../RationGrp';
import LateralDefile from '../LateralDefile';
import axios from 'axios';

const Groupe = ({ personnage, token }) => {
    const ip = process.env.REACT_APP_IP;
    const [groupList, setGroupList] = useState(parseGroupString(personnage.groupes));
    const [currentGroupe, setCurrentGroupe] = useState(groupList[0].idGroupe);
    const [listPerso, setListPerso] = useState(null);

    const fetchGroupe = async (groupeId) => {
        try {
            const response = await axios.get(`${ip}/groupe/${groupeId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setListPerso(response.data);
        } catch (error) {
            console.error('Une erreur s\'est produite lors de la récupération du personnage :', error);
        }
    };



    useEffect(() => {
        fetchGroupe(currentGroupe);
    }, [currentGroupe]);

    const handleGroupeChange = (value) => {
        setCurrentGroupe(value);
    };

    if (!listPerso) {
        return <div>Chargement membre en cours...</div>;
    }

    return (
        <div className='container-groupe  '>
            <div className='barre-lateral  wrapper--vertical marquee__group'></div>
            <div className='group-wrapper'>
                <div className='separator'><span className=''></span></div>
                <div className='titlegroup-wrapper'>
                    <div className=' rectangle'>
                        <select className='dropdown-groupe' onChange={(e) => handleGroupeChange(e.target.value)} value={currentGroupe}>
                            {groupList.map(group => (
                                <option key={group.idGroupe} value={group.idGroupe}>
                                    {group.nomGroupe}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className='image-groupe'>
                    {Object.entries(listPerso).map(([index, element]) => (
                        <div key={index}>
                            <img className="imageGroupe" src={element.personnage_groupPath} alt={element.personnage_prenom} />
                            <span>{element.personnage_prenom}</span>
                        </div>
                    ))}
                </div>

                <div className='margin-bot1-5'>
                    <span className='titre-groupe'>Ration commune</span>
                </div>
                <RationGrp idGroupe={currentGroupe} nbGroupe={listPerso.length} token={token}></RationGrp>
                <MoneyCounter idPerso={currentGroupe} groupe={"groupe"} token={token}></MoneyCounter>
            </div>
            <div className='barre-lateral '>

            </div>
            <LateralDefile></LateralDefile>
        </div>
    );
};

export default Groupe;
